import { CustomField } from '../../shared/model/customfieldsresponse';

export class StoreItemDetailResponse {
    iconData: string;
    iconMime: string;
    storeItemDescription: string;
    storeItemId: number;
    storeItemName: string;
    requestDescription: string;
    formSchema: string;
    showTargetDevice: boolean;
    targetDevices: (ItemInfoList)[] | null;
    customFields: (CustomField)[] | null;
}

export class ItemInfoList {
    itemId: number;
    itemName: string;
}
